import * as Yup from 'yup'
import React from "react";
import type { FormikHelpers } from 'formik';

type MakeScanAwareOpts = {
  threshold?: number
  onScan: (code: string) => void
  getValue?: (field: string) => string | number | null | undefined
}

export const getValidationSchema = () =>
  Yup.object().shape({
    productCode: Yup.string().required('Cod Produs este un câmp obligatoriu')
  })

export const initialValues = {
  productCode: ''
}

export function handleDecimalChange(
  setFieldValue: FormikHelpers<any>['setFieldValue']
) {
  return (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    let v = e.target.value

    if (!/^(\d+(\.\d*)?|\.\d*)$/.test(v) && v !== '') {
      return
    }

    if (v.length > 1 && v.startsWith('0') && v[1] !== '.') {
      v = v.replace(/^0+/, '')
    }

    setFieldValue(field, v)
  }
}

export function makeScanAwareDecimalChange(
  setFieldValue: FormikHelpers<any>['setFieldValue'],
  { threshold = 5, onScan, getValue }: MakeScanAwareOpts
) {
  const decimal = handleDecimalChange(setFieldValue)

  return (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value ?? ''

    const dot = raw.indexOf('.')
    const comma = raw.indexOf(',')
    const sepIdx =
      dot !== -1 && comma !== -1 ? Math.min(dot, comma) : (dot !== -1 ? dot : comma)
    const intPart = sepIdx === -1 ? raw : raw.slice(0, sepIdx)
    const intDigits = intPart.replace(/\D/g, '')

    if (intDigits.length > threshold) {
      let scanDigits = raw.replace(/\D/g, '')

      const prev = getValue ? String(getValue(field) ?? '') : ''
      if (prev === '0' && raw.startsWith('0') && scanDigits.length > 0) {
        scanDigits = scanDigits.slice(1)
      }

      setFieldValue(field, 0)
      onScan(scanDigits)
      return
    }

    return decimal(field)(e)
  }
}
